const STORAGE_KEY = "micoapp_recent_visits";
const MAX_ITEMS = 8;

/**
 * 添加最近访问的小程序
 * @param {{ appid: string, niconame: string, head_img?: string }} item
 */
export function addRecentVisit(item) {
  if (!item || !item.appid) return;
  const list = getRecentVisits();
  const filtered = list.filter((x) => x.appid !== item.appid);
  const newItem = {
    appid: item.appid,
    niconame: item.niconame || "未命名",
    head_img: item.head_img || "",
    visitedAt: Date.now(),
  };
  const updated = [newItem, ...filtered].slice(0, MAX_ITEMS);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (e) {
    console.warn("micoapp recent save failed", e);
  }
}

/**
 * 获取最近访问的小程序列表
 * @returns {Array<{ appid: string, niconame: string, head_img: string, visitedAt: number }>}
 */
export function getRecentVisits() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}
